import { black } from '@src/cnst/colors.cnst'
import { CeMark } from '@src/components/ce-mark/CeMark.component'
import { EighteenIcon } from '@src/components/eighteen-icon/EighteenIcon.component'
import { NoteIcon } from '@src/components/note-icon/NoteIcon.component'
import { languageContext } from '@src/context/language.context'
import type { ReactNode } from 'react'
import { useContext } from 'react'
import styles from './Disclaimer.module.scss'

export interface DisclaimerProps {
  effectivenessText: string
  eighteenText: string
  stiText: string
}

export function Disclaimer({
  effectivenessText,
  eighteenText,
  stiText,
}: DisclaimerProps): ReactNode {
  const { locale } = useContext(languageContext)

  return (
    <div className={styles.Disclaimer}>
      <div className={styles.Disclaimer__layout}>
        <EighteenIcon color={black} />
        <p className={styles.Disclaimer__text}>
          <span>{eighteenText}</span>
          <span>{stiText}</span>
        </p>

        <div className={styles.Disclaimer__clearances}>
          {locale === 'en-US' && <p className={styles.Disclaimer__clearancesText}> FDA Cleared </p>}
          <CeMark color={black} />
        </div>

        <NoteIcon color={black} />
        <p className={styles.Disclaimer__text}> {effectivenessText}</p>
      </div>
    </div>
  )
}
